import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import CJISRouter from './navigation/CJISRouter';

const store = configureStore();

const jsx = (
  <Provider store={store}>
    <CJISRouter />
  </Provider>
);

ReactDOM.render(jsx, document.getElementById('app'));


